import { get } from '../common/http';

class NoticeApi {
    static async getNoticeList(params) {
        const { page, count, keyword } = params;
        const res = await get(`/api/notices?page=${page}&count=${count}&keyword=${keyword}`);
        return res;
    }

    static async getNoticeDetail(id) {
        const res = await get(`/api/notices/${id}`);
        return res;
    }
}

export default NoticeApi;